import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CommentIcon from '@mui/icons-material/Comment';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import { useParams } from 'react-router-dom';

import SeeDetailsPage from 'shared/containers/SeeDetailsPage';
import {
  STATUS_INFO_TITLE,
  GENERAL_INFO_TITLE,
  ViewDetailsT,
  SETTINGS_TITLE,
} from 'shared/containers/ViewDetails/ViewDetails';
import { DeviceConfigT } from 'shared/models/device-configs';
import api from 'utils/api';
import { datePrettyDisplay } from 'utils/date';

function DeviceConfigDetails() {
  const { flowId, deviceProfileId, deviceConfigId }: any = useParams();

  const dataStructure: ViewDetailsT = {
    sections: [
      {
        title: STATUS_INFO_TITLE,
        items: [
          {
            type: 'status',
            label: 'Uplink Processing (Rx)',
            dataPath: 'ulStatus',
          },
          {
            type: 'status',
            label: 'Downlink Processing (Tx)',
            dataPath: 'dlStatus',
          },
          {
            label: 'Last LPWAN Frame',
            dataPath: 'lastActivityUl',
            renderFn: (value: string | null) => (value ? datePrettyDisplay(value) : 'No recent activity'),
            icon: <CallReceivedIcon color="primary" style={{ transform: 'rotate(180deg)' }} />,
          },
          {
            label: 'Last IP Packet',
            dataPath: 'lastActivityDl',
            renderFn: (value: string | null) => (value ? datePrettyDisplay(value) : 'No recent activity'),
            icon: <CallReceivedIcon color="primary" />,
          },
        ],
        shape: 2,
      },
      {
        title: GENERAL_INFO_TITLE,
        items: [
          {
            type: 'name',
          },
          {
            type: 'creation',
          },
          {
            label: 'Description',
            dataPath: 'comment',
            icon: <CommentIcon color="primary" />,
          },
          {
            type: 'update',
          },
          {
            label: 'Device Profile',
            dataPath: 'devProfileName',
            linkFn: (data: DeviceConfigT) => `/flows/${flowId}/device-profiles/${data.devProfileId}`,
          },
        ],
        shape: 2,
      },
      {
        title: SETTINGS_TITLE,
        items: [
          {
            label: 'Device ID',
            dataPath: 'deviceId',
            icon: <Grid3x3Icon color="primary" />,
          },
          {
            label: 'PSK ID',
            dataPath: 'pskID',
            hideOnEmpty: true,
          },
          {
            label: 'IPv6 Address',
            dataPath: 'addressIPv6',
            hideOnEmpty: true,
          },
          {
            label: 'IPv4 Address',
            dataPath: 'addressIPv4',
            hideOnEmpty: true,
          },
          {
            label: 'PSK Value',
            dataPath: 'pskValue',
            hideOnEmpty: true,
          },
        ],
        shape: 2,
      },
    ],
  };

  return (
    <>
      <SeeDetailsPage
        name="Device "
        targetID={deviceConfigId}
        apiCallParams={{ flowId, deviceProfileId }}
        fromAPI={api.deviceConfig}
        defaultURI={`/flows/${flowId}/device-profiles/${deviceProfileId}/devices`}
        onDeleteRedirectURI={`/flows/${flowId}`}
        dataStructure={dataStructure}
      />
    </>
  );
}

export default DeviceConfigDetails;
